import React from 'react'
import Accounts from 'components/offering/Account/Accounts'

interface AccountsProps { }

const AccountsPage: React.FC<AccountsProps> = () => (
    <Accounts />
  )

export default AccountsPage
